<template>
  <BlankPage :status="pageStatus" />
</template>

<script>
import { mapMutations } from 'vuex';
import commonTool from '@/utils/commonTool';
import mbcService from '@/services/mbcService';
import mmsService from '@/services/mmsService';
import ssoService from '@/services/ssoService';
import comService from '@/services/comService';
import BlankPage from '@/components/BlankPage.vue';

export default {
  components: {
    BlankPage,
  },
  data() {
    return {
      pageStatus: 'blank',
      memberSourceId: '',
      bindingMemberSourceId: '',
    };
  },
  created() {
    const vm = this;
    const {
      companyId, unionId, isRedirect, accountId, isLineLoginCallBack,
    } = vm.$route.query;

    this.set({ name: 'companyId', value: companyId });
    vm.companyId = companyId;
    sessionStorage.setItem('companyId', companyId);
    this.isLineLoginCallBack = isLineLoginCallBack;

    const isCallBack = true;
    // 導頁
    if (isRedirect === 'true') {
      mmsService
        .getQrCodeActivity({ companyId, unionId })
        .toPromise()
        .then((getQrCodeActivityRes) => {
          // 若查不到資料，導向錯誤頁
          if (getQrCodeActivityRes.response.status !== '200') {
            vm.$router.replace({
              name: 'Error',
              params: { status: 'activityNotExist' },
            });
          }
          const qrCodeActivity = getQrCodeActivityRes.response.data[0];
          vm.unionId = unionId;
          vm.memberSourceId = qrCodeActivity.memberSourceId;
          vm.bindingMemberSourceId = qrCodeActivity.bindingMemberSourceId;
          vm.accountId = accountId;
          this.set({ name: 'channelId', value: qrCodeActivity.channelId });
          this.channelId = qrCodeActivity.channelId;
          // 先判斷活動是否開始或已結束
          this.set({
            name: 'beforeWording',
            value:
              qrCodeActivity.message[0].object[0].property[0].propertyValue,
          });
          this.set({
            name: 'afterWording',
            value:
              qrCodeActivity.message[1].object[0].property[0].propertyValue,
          });

          if (qrCodeActivity.startTime > Date.now()) {
            this.activityNow = false;
            vm.$router.replace({
              name: 'Error',
              params: { status: 'activityBefore' },
            });
          } else if (qrCodeActivity.endTime < Date.now()) {
            this.activityNow = false;
            vm.$router.replace({
              name: 'Error',
              params: { status: 'activityAfter' },
            });
            // 判斷是否為外部連結
          } else if (qrCodeActivity.typeNo === 3 || qrCodeActivity.typeNo === 1) {
            vm.getMemberAccount(qrCodeActivity.typeNo === 3).then(
              (memberAccount) => {
                if (qrCodeActivity.typeNo === 3 || (qrCodeActivity.typeNo === 1 && memberAccount?.accountType === 'LineBind')) {
                  vm.accountId = memberAccount.accountID;
                  vm.accountType = memberAccount.accountType;
                  commonTool.goToRedirectUrl(
                    qrCodeActivity,
                    vm.companyId,
                    vm.accountType,
                    vm.accountId,
                    vm.unionId,
                    qrCodeActivity.memberSourceId,
                    isCallBack,
                  );
                } else {
                  this.goToLineLogin();
                }
              },
            );
          } else {
            const memberSourceId = qrCodeActivity.bindingMemberSourceId
              ? qrCodeActivity.bindingMemberSourceId
              : qrCodeActivity.memberSourceId;
            commonTool.goToRedirectUrl(
              qrCodeActivity,
              vm.companyId,
              vm.accountType,
              vm.accountId,
              vm.unionId,
              memberSourceId,
              isCallBack,
            );
          }
        })
        .catch(() => {
          vm.$router.replace({
            name: 'Error',
            params: { status: 'activityNotExist' },
          });
        });
    } else {
      mmsService
        .getQrCodeActivity({ companyId, unionId })
        .toPromise()
        .then((getQrCodeActivityRes) => {
          const qrCodeActivity = getQrCodeActivityRes.response.data[0];
          vm.memberSourceId = qrCodeActivity.memberSourceId;
          vm.bindingMemberSourceId = qrCodeActivity.bindingMemberSourceId;
          this.set({ name: 'channelId', value: qrCodeActivity.channelId });
          this.channelId = qrCodeActivity.channelId;
          // 取得會員帳號後，檢查是否為好友、發訊息
          vm.getMemberAccount().then((memberAccount) => {
            if (
              memberAccount
              && memberAccount.accountID
              && memberAccount.accountType === 'LineBind'
            ) {
              commonTool.checkFriendAndSendLineMessage(
                memberAccount.accountID,
                companyId,
                unionId,
              );
            } else {
              this.goToLineLogin();
            }
          });
        })
        .catch(() => {
          vm.$router.replace({
            name: 'Error',
            params: { status: 'activityNotExist' },
          });
        });
    }
  },
  methods: {
    ...mapMutations(['set']),
    // 取得 access token
    getAccessToken(query) {
      const body = {
        companyId: query.companyId,
        memberSourceId: query.memberSourceId,
        code: query.code,
      };

      return ssoService
        .getDigest(query.companyId, query.memberSourceId, body)
        .toPromise()
        .then((res) => {
          const headers = { digest: res.response.data[0].digest };
          return ssoService
            .getAccessToken(body, headers)
            .toPromise()
            .then((rsp) => rsp.response.data[0].accessToken);
        })
        .catch(() => {
          this.$router.replace({
            name: 'Error',
            params: { status: 'unstableNetwork' },
          });
        });
    },
    // 取得會員帳號
    getMemberAccount(isExternal = false) {
      const vm = this;
      // 先取得 access token 再取得會員帳號資料
      return vm
        .getAccessToken(vm.$route.query)
        .then((accessToken) => mbcService
          .getMemberAccount({ isGetAll: true }, { accessToken })
          .toPromise()
          .then((res) => {
            this.memberData = res.response.data[0].account;
            if (isExternal) {
              // 優先找到Mobile資料，再來是Email
              const accountTypeArr = ['Mobile', 'Email'];
              let accountTypeResult;
              let isFind = false;
              accountTypeArr.forEach((accountType) => {
                if (isFind) return;
                if (
                  res.response.data[0].account.find(
                    (x) => x.accountType === accountType,
                  )
                ) {
                  isFind = true;
                  accountTypeResult = accountType;
                }
              });
              return res.response.data[0].account.find(
                (x) => x.accountType === accountTypeResult,
              );
            }
            if (
              res.response.data[0].account.find(
                (x) => x.accountType === 'LineBind',
              )
            ) {
              return res.response.data[0].account.find(
                (x) => x.accountType === 'LineBind'
                    && x.memberSourceId
                      === (vm.bindingMemberSourceId
                        ? vm.bindingMemberSourceId
                        : vm.memberSourceId),
              );
            }
            return null;
          }))
        .catch(() => {
          vm.$router.replace({
            name: 'Error',
            params: { status: 'unstableNetwork' },
          });
        });
    },

    // 前往Line Login
    goToLineLogin() {
      const vm = this;
      const {
        companyId, unionId,
      } = vm.$route.query;

      const href = window.location.href
        .split('?')
        .shift()
        .split('#')
        .shift()
        .replace(/\/$/, '')
        .replace(vm.$route.path, '');
      const redirectQueryString = new URLSearchParams({
        companyId,
        unionId,
        ChannelID: vm.channelId,
        isMemberBinding: true,
        identifySource: this.memberData[0].identifySource,
      }).toString();
      const redirectUrl = encodeURIComponent(`${href}/qrCode/lineLoginCallback?${redirectQueryString}`);
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
        ? '${VUE_APP_API_COM_URL}'
        : process.env.VUE_APP_API_COM_URL;
      const lineLoginUrl = `${comUrl}/api/v1/lineCode?DirectUrl=${redirectUrl}&CompanyId=${vm.companyId}&ChannelID=${vm.channelId}`;

      // 跳轉至 Line Login
      window.location.assign(lineLoginUrl);
    },

    // 取得 Line UserId
    getLineUserId(companyId, redirectUri, code, memberSourceID) {
      const params = new URLSearchParams({ companyId, redirectUri });

      // 有memberSourceID才新增
      if (memberSourceID) {
        params.append('memberSourceID', memberSourceID);
      }

      const redirectQueryString = params.toString();
      const directUrl = `${window.location.origin}${window.location.pathname}?${redirectQueryString}`;
      const body = {
        companyId,
        code,
        directUrl,
      };

      return comService
        .getLineUserId(body)
        .toPromise()
        .then((res) => res.response.data.userID)
        .catch(() => {
          this.$router.replace({
            name: 'Error',
            params: { status: 'authorization' },
          });
        });
    },
  },
};
</script>
